Controller = App.loadClass 'core::Angular/Controller'

class exports.ApplicationDetailsController extends Controller
    constructor: (
        @scope,
        @transitions,
        @modal,
        @http,
        @service,
        @state,
        @q,
        @ngModal,
    ) ->
        super

        @launchDialogTriggers = {}
        @fieldSurveyForNewMachinery = null
        @newMachinery = (machinery) =>
            typeId = machinery.type.id
            letter = switch typeId
                when 3 then 's'
                when 4 then 'f'
            return unless letter?
            machineId = letter + machinery.id
            @loadApplicators()
            .then () =>
                for applicator in @applicators
                    if applicator.id is machineId and @filterApplicators(@fieldSurveyForNewMachinery)(applicator)
                        @fieldSurveyForNewMachinery.data.applicator = machineId
                        return

        @applicators = []
        @loadApplicators()
        @loadSources()
        @loadUnitTypes()

        # https://www.pivotaltracker.com/story/show/159076191
        for i in [0..@service.survey.fields_nitrogen_surveys.length - 1]
            func = (index) =>
                @scope.$watch "service.survey.fields_nitrogen_surveys[#{i}].data.rate", (newRate, oldRate) =>
                    if newRate is 'Variable Rate' and not @selectedApplicatorIsVariableRate(@service.survey.fields_nitrogen_surveys[index])
                        @service.survey.fields_nitrogen_surveys[index].data.rate = oldRate
            func(i)

    sourceChanged: (fieldSurvey) =>
        return if not fieldSurvey.data.source
        # set whether the source was a custom source or not
        fieldSurvey.data.source_is_custom = (_.find @sources, { id: fieldSurvey.data.source }).is_custom

    loadUnitTypes: () ->
        @http.get 'backend/grower/layers/fertilizer/custom-source-unit-options'
        .then (response) =>
            @unitOptions = response.data

    loadApplicators: () ->
        fertilizerPromise = @http.get 'api/machinery-fertilizers'
        .then (response) =>
            applicators = []
            for fertilizer in response.data
                if fertilizer.fertilizer_source_type?
                    applicators.push
                        id: 'f' + fertilizer.id
                        name: "#{fertilizer.name} (#{fertilizer.fertilizer_source_type}/#{fertilizer.app_method})"
                        application_method: fertilizer.app_method
                        fertilizer_source_type: fertilizer.fertilizer_source_type
                        variable_rate: fertilizer.variable_rate
                else
                    applicators.push
                        id: 'f' + fertilizer.id
                        name: "#{fertilizer.name} (#{fertilizer.app_method})"
                        application_method: fertilizer.app_method
                        fertilizer_source_type: fertilizer.fertilizer_source_type
                        variable_rate: fertilizer.variable_rate

            return applicators

        sprayerPromise = @http.get 'api/machinery-sprayers'
        .then (response) =>
            applicators = []
            for sprayer in response.data
                if sprayer.used_for_fertilizer
                    applicators.push
                        id: 's' + sprayer.id
                        name: "#{sprayer.name} (Liquid/#{sprayer.app_method})"
                        application_method: sprayer.app_method
                        fertilizer_source_type: sprayer.fertilizer_source_type
                        variable_rate: sprayer.variable_rate

            return applicators

        return @q.all([ fertilizerPromise, sprayerPromise ]).then (applicators) =>
            [fertilizers, sprayers] = applicators
            @applicators = [].concat fertilizers, sprayers

            return @applicators

    loadSources: () =>
        @sources = []
        @http.get 'backend/grower/layers/fertilizer/sources'
        .then (response) =>
            @sources = _.filter response.data, (source) =>
                parseFloat(source.nitrogen) > 0

    filterSources: (applicatorId) =>
        applicator = _.find @applicators, { id: applicatorId }
        return (source) =>
            if not applicator?
                return true

            return @sourceValidForApplicator source, applicator

    sourceValidForApplicator: (source, applicator) =>
        if source.is_manure
            return false

        if source.application_type is 'Anhydrous' and applicator.application_method isnt 'Anhydrous Ammonia'
            return false

        if source.application_type is 'Liquid' and applicator.fertilizer_source_type?.toLowerCase() is 'dry'
            return false

        return true

    clearInvalidSource: (fieldSurvey) =>
        source = _.find @sources, { id: fieldSurvey.data.source }
        applicator = _.find @applicators, { id: fieldSurvey.data.applicator }

        if source and applicator and not @sourceValidForApplicator source, applicator
            fieldSurvey.data.source = null

    launchAddSourceDialog: (fieldSurvey, inputName) =>
        applicator = @applicators.find((item) =>
            return item.id is fieldSurvey.data['applicator']
        )

        if fieldSurvey.data['applicator'].includes('s') or fieldSurvey.data['applicator'].includes('p')
            # we have a sprayer or planter so its liquid by default
            applicatorIsLiquid = true
        else if fieldSurvey.data['applicator'].includes('f')
            # we have a fertilizer, so it could be either
            applicatorIsLiquid = applicator.fertilizer_source_type is 'liquid' and applicator.application_method isnt 'Anhydrous Amonia'

        @ngModal.openAddSourceDialog(applicatorIsLiquid, @unitOptions)
        .modalRef.result.then (result) =>
            @loadSources()
            @fieldSurvey.data[inputName] = result.id
        .catch _.noop

    launchAddApplicatorDialog: (fieldSurvey) ->
        if not @launchDialogTriggers[fieldSurvey.id]
            @launchDialogTriggers[fieldSurvey.id] = 0
        @launchDialogTriggers[fieldSurvey.id]++
        @fieldSurveyForNewMachinery = fieldSurvey

    filterApplicators: (fieldSurvey) ->
        (applicator) ->
            if fieldSurvey.data['rate'] is 'Variable Rate'
                return applicator.variable_rate
            return true

    selectedApplicatorIsVariableRate: (fieldSurvey) ->
        id = fieldSurvey.data.applicator

        # https://www.pivotaltracker.com/story/show/158974673
        if not id
            return true

        for applicator in @applicators
            if applicator.id is id
                return applicator.variable_rate
